// DS9.2
import React from 'react';
import classnames from 'classnames';
import HoverOnly from '../OverlayHelpers/HoverOnly';
import MediaIndicator from '../MediaIndicator';
import EngagementIndicator from '../EngagementIndicator';

import s from './ThumbOverlayDefault.scss';

interface Props {
  isFaved?: boolean;
  isCommented?: boolean;
  statusIndicators?: React.ReactNode;
  mediaIndicator?: 'gif' | 'video';
  isMultiImage?: boolean;
  duration?: number;
  width?: number;
  height?: number;
  className?: string;
}

const ThumbOverlayDefault: React.FC<React.PropsWithChildren<Props>> = ({
  isFaved,
  isCommented,
  isMultiImage,
  statusIndicators,
  mediaIndicator,
  duration,
  width,
  height,
  className,
  children,
}) => {
  const isTooNarrow = width && width < 120;
  const isTooShort = height && height < 120;

  return (
    <div style={{ width, height }} className={classnames(s['root'], className)}>
      <div className={s['top']}>
        {!isTooShort && (
          <>
            <div className={classnames(s['left'], s['indicators'])}>
              {!isTooNarrow && statusIndicators}
            </div>
            <div className={s['right']}>
              {(mediaIndicator || isMultiImage) && (
                <HoverOnly reverseHidden>
                  <MediaIndicator
                    type={mediaIndicator}
                    duration={duration}
                    isMultiImage={isMultiImage}
                  />
                </HoverOnly>
              )}
            </div>
          </>
        )}
      </div>
      <div className={s['middle']}>
        {!isTooNarrow && !isTooShort && children}
      </div>
      <div className={s['bottom']}>
        <div className={s['left']} />
        <HoverOnly
          reverseHidden
          className={classnames(s['right'], s['engagement'])}
        >
          {isCommented && <EngagementIndicator type="comment" />}
          {isFaved && <EngagementIndicator type="fave" />}
        </HoverOnly>
      </div>
    </div>
  );
};
ThumbOverlayDefault.displayName = 'ThumbOverlayDefault';

export default ThumbOverlayDefault;
